import AmplitudeService from '@/services/AmplitudeService'

export default {
  install(Vue) {
    Vue.prototype.$amplitude = AmplitudeService
  }
};
